import { __decorate, __param } from "tslib";
import { Inject, Injectable, Optional } from "@angular/core";
import { TranslateCompiler } from "@ngx-translate/core";
import * as MessageFormat from "messageformat";
import { defaultConfig, MESSAGE_FORMAT_CONFIG, } from "./message-format-config";
/**
 * This compiler expects ICU syntax and compiles the expressions with messageformat.js
 */
import * as ɵngcc0 from '@angular/core';
let TranslateMessageFormatCompiler = class TranslateMessageFormatCompiler extends TranslateCompiler {
    constructor(config) {
        super();
        const { locales, formatters, biDiSupport, strictNumberSign, disablePluralKeyChecks, } = Object.assign(Object.assign({}, defaultConfig), config);
        this.messageFormat = new MessageFormat(locales);
        if (formatters) {
            this.messageFormat.addFormatters(formatters);
        }
        if (biDiSupport) {
            this.messageFormat.setBiDiSupport(biDiSupport);
        }
        if (strictNumberSign) {
            this.messageFormat.setStrictNumberSign(strictNumberSign);
        }
        if (disablePluralKeyChecks) {
            this.messageFormat.disablePluralKeyChecks();
        }
    }
    compile(value, lang) {
        return this.messageFormat.compile(value, lang);
    }
    compileTranslations(translations, lang) {
        return this.messageFormat.compile(translations, lang);
    }
};
TranslateMessageFormatCompiler.ɵfac = function TranslateMessageFormatCompiler_Factory(t) { return new (t || TranslateMessageFormatCompiler)(ɵngcc0.ɵɵinject(MESSAGE_FORMAT_CONFIG, 8)); };
TranslateMessageFormatCompiler.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TranslateMessageFormatCompiler, factory: function (t) { return TranslateMessageFormatCompiler.ɵfac(t); } });
TranslateMessageFormatCompiler.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MESSAGE_FORMAT_CONFIG,] }] }
];
TranslateMessageFormatCompiler = __decorate([ __param(0, Optional()),
    __param(0, Inject(MESSAGE_FORMAT_CONFIG))
], TranslateMessageFormatCompiler);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TranslateMessageFormatCompiler, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MESSAGE_FORMAT_CONFIG]
            }] }]; }, null); })();
export { TranslateMessageFormatCompiler };

